<div class="app-body">
    <main class="main d-flex align-items-center">
        <div class="container">
            <div class="row">
                <div class="col-md-8 mx-auto">
                    <div class="text-center my-5">
                        <h1 class="display-4 fw-bold text-primary">Kontaktieren Sie uns</h1>
                        <div class="border-bottom border-primary mx-auto" style="width: 100px; margin-top: 15px;"></div>
                    </div>

                    <div class="card mt-3 shadow-sm">
                        <div class="card-header bg-primary text-white">
                            <h3 class="mb-0">Kontakt</h3>
                        </div>
                        <div class="card-body">
                            <form [formGroup]="form">
                                <p>Willkommen bei NoteRadar! Haben Sie Fragen zu unserer innovativen Plattform, benötigen Sie weitere Informationen oder möchten Sie eine persönliche Demo-Präsentation vereinbaren? Unser Expertenteam steht Ihnen gerne zur Verfügung und freut sich darauf, Ihnen bei allen Anliegen rund um NoteRadar zu helfen.</p>

                                <div class="form-group mb-3">
                                    <label class="form-label fw-bold">E-Mail</label>
                                    <input type="text" class="form-control" formControlName="email" appAutofocus>
                                </div>

                                <div class="form-group mb-3">
                                    <label class="form-label fw-bold">Nachricht</label>
                                    <textarea class="form-control" formControlName="message" rows="5"></textarea>
                                </div>
                            </form>
                        </div>
                        <div class="card-footer">
                            <button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="sendMessage()">Nachricht senden</button>
                        </div>
                    </div>

                    <div class="alternative-contact mt-4 mb-5 p-4 bg-light rounded text-center">
                        <h4 class="mb-3">Weitere Kontaktmöglichkeiten</h4>
                        <p>Alternativ schicken Sie uns einfach eine E-Mail an <a href="mailto:info@noteradar.at">info&#64;noteradar.at</a></p>

                        <div class="contact-info mt-4">
                            <div class="row">
                                <div class="col-md-6 mb-3">
                                    <div class="contact-item">
                                        <i class="fas fa-clock text-primary mb-2"></i>
                                        <h5>Geschäftszeiten</h5>
                                        <p>Montag - Freitag: 9:00 - 17:00 Uhr</p>
                                    </div>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <div class="contact-item">
                                        <i class="fas fa-envelope text-primary mb-2"></i>
                                        <h5>Support</h5>
                                        <p>Wir antworten in der Regel innerhalb von 24 Stunden</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
